// ─── DeviceContext.jsx ───────────────────────────────────────────────────────
// Smart city device/sensor context badge.
// Infers device type from source IP subnet — maps subnets to sensor zones.
//


import React from 'react';

const mono = { fontFamily: 'JetBrains Mono, monospace' };


const SUBNET_MAP = {
  '10.0':     { type: 'SCADA',    label: 'SCADA Node',    icon: '⚡', color: '#f59e0b' },
  '10.10':    { type: 'TRAFFIC',  label: 'Traffic Sensor',icon: '🚦', color: '#3b82f6' },
  '10.20':    { type: 'CAMERA',   label: 'IP Camera',     icon: '📷', color: '#06b6d4' },
  '192.168':  { type: 'METER',    label: 'Smart Meter',   icon: '📊', color: '#8b5cf6' },
  '172.16':   { type: 'GATEWAY',  label: 'IoT Gateway',   icon: '🔗', color: '#10b981' },
  '172.17':   { type: 'SERVER',   label: 'City Server',   icon: '🖥', color: '#6b7280'  },
};

export function getDeviceType(ip) {
  if (!ip) return null;
  const parts = ip.split('.');
  if (parts.length < 2) return null;
  const key2 = `${parts[0]}.${parts[1]}`;
  return SUBNET_MAP[key2] || { type: 'UNKNOWN', label: 'Unknown Device', icon: '❓', color: '#4b5563' };
}

export default function DeviceContext({ ip }) {
  const device = getDeviceType(ip);
  if (!device) return <span style={{ color: '#374151', fontSize: 10, ...mono }}>—</span>;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      <span style={{ fontSize: 11 }}>{device.icon}</span>
      <span style={{
        fontSize: 9, ...mono, fontWeight: 500,
        color: device.color,
        background: `${device.color}18`,
        border: `1px solid ${device.color}33`,
        padding: '1px 6px', borderRadius: 3,
        whiteSpace: 'nowrap',
      }}>
        {device.label}
      </span>
    </div>
  );
}
